import { inject, Pipe, PipeTransform } from '@angular/core';
import { User } from '@isophi/core-legacy';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'formatUserRole',
  standalone: false,
})
export class FormatUserRolePipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(value: User): string {
    if (value.teacher?.isDirector()) {
      return this.translocoService.translate('user/director');
    }
    if (value.teacher?.isManager()) {
      return this.translocoService.translate('user/manager');
    }
    return this.translocoService.translate('user/teacher');
  }
}
